import { AgentBase } from './agentBase';

import type { Command, Manager } from '../lib';

export class Human extends AgentBase {
	public getCommand(game: Manager):Command | null {
		
		const gameState = game.gameState;

		switch (gameState.roundStage) {
			default:
				return null;
				// case RoundStage.RoundEnd:
				// 	return resolve(makeNextStageCommand());
		}
		
	}

}
